<template>
  <div class="common-table">
    <el-table :data="tableData" style="width: 100%" :header-cell-style="headerStyle">
      <el-table-column
        v-if="table.hasSelect"
        type="selection"
        width="55"
        align="center"
      ></el-table-column>
      <el-table-column type="index" width="60" label="序号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(column, index) in table.columns"
        :prop="column.prop"
        :key="index"
        :label="column.label"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="column.type">
            <span v-if="column.type == 'status'">
              <el-tag type="primary" v-show="scope.row[column.prop] == 0">待审核</el-tag>
              <el-tag type="warning" v-show="scope.row[column.prop] == 1">审核中</el-tag>
              <el-tag type="warning" v-show="scope.row[column.prop] == 2">已退回</el-tag>
              <el-tag type="success" v-show="scope.row[column.prop] == 6">待用户确认</el-tag>
              <el-tag type="success" v-show="scope.row[column.prop] == 4">待上传终极查新报告</el-tag>
              <el-tag type="success" v-show="scope.row[column.prop] == 5">已完成</el-tag>
              <!-- 暂无没有状态2的参数，先注释后期添加
              <el-tag type="success" v-show="scope.row[column.prop] == 2 "
                >科技主管审核</el-tag
              > -->
              <el-tag type="success" v-show="scope.row[column.prop] == 3">已完成</el-tag>
            </span>
          </span>
          <span v-if="!column.type">{{ scope.row[column.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="170" v-if="table.hasBtn" align="center">
        <template slot-scope="scope">
          <el-button
            :type="item.type"
            size="small"
            v-for="(item, index) in table.btns"
            :key="index"
            @click="clickEvent(item, scope.row)"
            v-if="scope.row['status'] == 1 || scope.row['status'] == 4"
          >
            {{ item.name }}
          </el-button>
          <el-button
            slot="reference"
            type="primary"
            size="small"
            v-if="scope.row['status'] == 0"
            @click="accept(scope.row)"
          >
            确认受理
          </el-button>
          <el-button slot="reference" type="success" size="small" @click="decline(scope.row)">
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="display: flex; justify-content: center">
      <el-pagination
        @current-change="handleCurrentChange"
        :hide-on-single-page="true"
        :current-page.sync="current_page"
        :page-size="per_page"
        layout="total, prev, pager, next"
        :total="total"
        prev-text="上一页"
        next-text="下一页"
        style="text-align: left; margin: 20px 0"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: ["table", "url", "tableParams"],
  data() {
    return {
      visible: false,
      current_page: 1,
      per_page: 10,
      total: 10,
      headerStyle: {
        color: "#623aa2",
        background: "#E5F3FE",
      },
      tableData: [],
      phoneType: ["电话", "手机号", "微信号"],
      params: {},
    };
  },

  methods: {
    accept(row) {
      this.$confirm("确定要受理吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let url = `${
          this.urlConfig.devUrl
        }apij2/admin-api/voucher/technology-novelty-search/confirm-acceptance?id=${
          row.id
        }&status=${1}`;
        this.http.put(url).then(res => {
          if (res.data) {
            this.$message({
              message: "受理成功",
              type: "success",
            });
            this.visible = false;
            this.getData();
          }
        });
      });
    },
    clickEvent(item, row) {
      this.$emit(item.event, row);
    },
    handleCurrentChange(val) {
      this.getData();
    },
    // 获取评价申请列表
    search(row) {
      console.log(row);
      this.params = { ...this.params,...row};
      // this.params.projectName=row.projectName
      // this.params.status=row.status
      this.getData();
    },
    getData() {
      this.params.page = this.current_page;
      this.params.pageSize = this.per_page;
      this.http.post(this.url, this.params).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.per_page = Number(res.data.per_page);
          this.total = res.data.total;
          this.current_page = res.data.current_page;
        } else {
          this.$message.error("获取数据失败！！");
        }
      });
    },
    decline(row) {
      this.$emit("decline", row);
    },
  },
  watch: {
    tableParams: {
      handler(val) {
        if (val) {
          this.params = val;
          if (val.status === "") {
            delete this.params.status;
          }
          this.getData(this.url);
        }
      },
      immediate: true,
    },
    url: {
      handler(val) {
        if (val) {
          this.getData(val);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.el-rate {
  cursor: pointer;
}
</style>
